import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { OidcSecurityService, UserDataResult } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FormControl } from '@angular/forms';
import { map, startWith, tap } from 'rxjs/operators';
import { AudioProcessorTask, IAudioProcessorTask, IAudioProcessorTaskBlock } from '../../../../../core/models/audio-processor-task.model';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TaskModel } from '../../../task.model';
import DataSource from 'devextreme/data/data_source';

@Component({
  selector: 'app-task-viewer-tile-details',
  templateUrl: 'task.viewer.tile.details.component.html',
  styleUrls: ['task.viewer.tile.details.component.scss']
})
  
export class TaskViewerTileDetailsComponent implements OnInit {
  public result: any = false;
  dataSource: any[] = [];
  scrolling: any = {
    columnRenderingMode: 'virtual'
  };
  searchPanel: any = {
    visible: true
  }
  constructor(
    private taskModel: TaskModel,
    public dialogRef: MatDialogRef<TaskViewerTileDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IAudioProcessorTask,
  ) {
  }

  onNoClick(): void {
    this.result = false;
    this.dialogRef.close(this.result);
  }

  onYesClick(): void {
    this.result = true;
    this.dialogRef.close(this.result);
  }

  getStatus(task: any) {
    switch (task.status) {
      case 0: return "Pending";
      case 1: return "Running";
      case 2: return "Done";
      case 3: return "Error";
    }

    return "Unknown";
  }

  getMenuItems(block: IAudioProcessorTaskBlock) {
    let result = "";

    for (var i = 0; i < block.menuItems.length; i++) {
      let menuItem = block.menuItems[i];
      result += menuItem.caption + " "
    }

    return result;

  }

  getPlugin(pluginId: string) {
    return this.taskModel.plugins.filter(item => { return item.id === pluginId })[0];
  }

  ngOnInit() {
    this.initializeData();

  }

  onGridReady(event: any) {

  }

  initializeData() {
    let converted = [];
    const blocks = this.data.taskBlocks;
    for (var i = 0; i < blocks.length; i++) {
      let element = blocks[i];
      converted.push({
        FileName: element.originalFileName,
        TaskType: this.getPlugin(element.pluginId).caption,
        //Status: this.getStatus(element),
        FromMicrophone: element.menuItems[0].caption,
        ToMicrophone: element.menuItems[1].caption,
        Size: Math.round(element.fileSize / 10000) / 100 + " MB"
        })
    }
    this.dataSource = converted;
  }
}
